import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';
import { Delivery } from './delivery';

@Injectable()
export class DeliveryService implements Resolve<any> {
  public rows: any;
  public onDeliveryListChanged: BehaviorSubject<any>;

  constructor(private _httpClient: HttpClient, public _authenticationService: AuthenticationService) {
    this.onDeliveryListChanged = new BehaviorSubject({});
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return new Promise<void>((resolve, reject) => {
      Promise.all([this.getAllDeliveries()]).then(() => {
        resolve();
      }, reject);
    });
  }

  getAllDeliveries(ignoreSubjects = false): Promise<Delivery[]> {
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.get(`${environment.apiUrl}/v1/deliveries`, { headers }).subscribe((response: any) => {
        this.rows = response.results;
        if (!ignoreSubjects) {
          this.onDeliveryListChanged.next(this.rows);
        }
        resolve(this.rows);
      }, reject);
    });
  }

  createDelivery(delivery): Promise<void> {
    delete delivery.id;
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.post(`${environment.apiUrl}/v1/deliveries`, delivery, { headers }).subscribe((response: any) => {
        this.getAllDeliveries();
        resolve();
      }, reject);
    });
  }

  updateDelivery(delivery): Promise<void> {
    delete delivery.ownedBy;
    const headers = this._authenticationService.getAccessTokenHeader();
    return new Promise((resolve, reject) => {
      this._httpClient.patch(`${environment.apiUrl}/v1/deliveries/${delivery.id}`, delivery, { headers }).subscribe((response: any) => {
        this.getAllDeliveries();
        resolve();
      }, reject);
    });
  }
}
